export default __webpack_public_path__ + "static/media/chassis.3c973195.svg";